<template>
  <div class="ratings-downloads">
    <h2 class="ratings-downloads__title">
      <span v-html="ratings" /> | <span v-html="downloads" />
    </h2>
    <div class="ratings-downloads__footer">
      <nuxt-icon
        name="icon_stars_icons"
        filled
        class="ratings-downloads__icons"
      />
      <div class="ratings-downloads__rate">
        <span v-html="rate" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps({
  ratings: { type: String, required: true },
  downloads: { type: String, required: true },
  rate: { type: String, required: true },
});
</script>

<style lang="scss" scoped>
.ratings-downloads {
  display: flex;
  flex-direction: column;
  align-items: center;

  &__title {
    color: #111113;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 118.5%;

    & span {
      font-weight: inherit;
      font-size: inherit;
      line-height: inherit;

      & :deep(.bold) {
        font-weight: 600;
      }
    }
  }

  &__footer {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-top: 11px;
  }

  &__icons {
    font-size: 20px;

    & :deep(svg) {
      width: 106px;
      height: 20px;
    }
  }

  &__rate {
    border-radius: 5px;
    background: $text-color;
    color: $white;
    padding: 7px 15px;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 118.5%;

    & span {
      & :deep(.bold) {
        font-weight: 700;
      }
    }
  }
}
</style>
